<template>
  <v-dialog v-model="show" max-width="450">
    <v-card>
      <v-card-title
        class="justify-center text-xs-center purple--text title"
        v-if="header"
      >{{header}}</v-card-title>
      <v-card-text class="message text-xs-center" v-if="message">{{message}}</v-card-text>
      <v-card-actions v-if="buttonText || secondaryBtnText" class="justify-center">
        <v-btn v-if="buttonText" small color="purple" dark @click="apply">{{buttonText}}</v-btn>
        <v-btn
          v-if="secondaryBtnText"
          outline
          small
          color="purple"
          @click="secondaryApply"
        >{{secondaryBtnText}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "showModal",

  props: {
    value: Boolean,
    message: String,
    header: String,
    buttonText: String,
    secondaryBtnText: String
  },

  data: () => ({
    show: false
  }),

  methods: {
    apply() {
      this.$emit("on-apply");
    },

    secondaryApply() {
      this.$emit("on-secondaryApply");
    },

    closeModal() {
      this.show = false;
    }
  },

  mounted() {
    this.show = this.value;
  },

  watch: {
    value(value) {
      this.show = value;
    },
    show(value) {
      this.$emit("input", this.show);
    }
  }
};
</script>

<style lang="scss" scoped>
.v-dialog .v-card .v-card__actions .v-btn {
  min-width: 80px;
}

.message {
  padding-top: 20px !important;
}
</style>